var _regeneratorRuntime = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

var ProviderEngine = require("web3-provider-engine");

var FiltersSubprovider = require("web3-provider-engine/subproviders/filters.js");

var NonceSubProvider = require("web3-provider-engine/subproviders/nonce-tracker.js");

var HookedSubprovider = require("web3-provider-engine/subproviders/hooked-wallet.js");

var ProviderSubprovider = require("web3-provider-engine/subproviders/provider.js");

var ProxyProvider =
/*#__PURE__*/
function () {
  "use strict";

  function ProxyProvider(network, core) {
    _classCallCheck(this, ProxyProvider);

    this.network = network;
    this.core = core;
    this.engine = new ProviderEngine();
    this.engine.addProvider({
      handleRequest: function () {
        var _handleRequest = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(payload, next, end) {
          var result;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;

                  if (!(payload.method === 'eth_sendTransaction' && core.shouldSkipSigning(network, payload.params[0]))) {
                    _context.next = 8;
                    break;
                  }

                  _context.next = 4;
                  return core.handleRequest(network, payload);

                case 4:
                  result = _context.sent;
                  end(null, result);
                  _context.next = 9;
                  break;

                case 8:
                  next();

                case 9:
                  _context.next = 14;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](0);
                  end(_context.t0);

                case 14:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 11]]);
        }));

        function handleRequest(_x, _x2, _x3) {
          return _handleRequest.apply(this, arguments);
        }

        return handleRequest;
      }(),
      setEngine: function setEngine() {}
    });
    this.engine.addProvider(new HookedSubprovider({
      getAccounts: function () {
        var _getAccounts = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2(cb) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.t0 = cb;
                  _context2.next = 4;
                  return core.getAccounts();

                case 4:
                  _context2.t1 = _context2.sent;
                  (0, _context2.t0)(null, _context2.t1);
                  _context2.next = 11;
                  break;

                case 8:
                  _context2.prev = 8;
                  _context2.t2 = _context2["catch"](0);
                  cb(_context2.t2);

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 8]]);
        }));

        function getAccounts(_x4) {
          return _getAccounts.apply(this, arguments);
        }

        return getAccounts;
      }(),
      signTransaction: function signTransaction(txParams, cb) {
        txParams.chainId = +network;
        core.signTx(txParams).then(function (signedTx) {
          return cb(null, signedTx);
        }).catch(function (err) {
          return cb(err);
        });
      },
      signMessage: function signMessage(_ref, cb) {
        var data = _ref.data,
            from = _ref.from;
        core.signMsg(data, from).then(function (signature) {
          return cb(null, signature);
        }).catch(function (err) {
          return cb(err);
        });
      },
      signPersonalMessage: function signPersonalMessage(_ref2, cb) {
        var data = _ref2.data,
            from = _ref2.from;
        core.signMsg(data, from).then(function (signature) {
          return cb(null, signature);
        }).catch(function (err) {
          return cb(err);
        });
      }
    })); //this.engine.addProvider(new GaspriceProvider());

    this.engine.addProvider(new NonceSubProvider());
    this.engine.addProvider(new FiltersSubprovider());
    this.engine.addProvider({
      handleRequest: function handleRequest(payload, next, end) {
        core.handleRequest(network, payload).then(function (result) {
          try {
            end(null, result);
          } catch (err) {
            if (err.message !== 'Could not find block') {
              throw err;
            }
          }
        }).catch(function (err) {
          return end(err);
        });
      },
      setEngine: function setEngine() {}
    });
    this.engine.start();
  }

  _createClass(ProxyProvider, [{
    key: "stop",
    value: function stop() {
      this.engine.stop();
    }
  }, {
    key: "sendAsync",
    value: function sendAsync() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.engine.sendAsync.apply(this.engine, args);
    }
  }, {
    key: "send",
    value: function send() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.engine.send.apply(this.engine, args);
    }
  }]);

  return ProxyProvider;
}();

module.exports = ProxyProvider;